import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

const useDispatchAction = (action, payload, initialValue, enabled = true, onError) => {
  const dispatch = useDispatch();
  const [data, setData] = useState(initialValue ?? null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!enabled) {
      setIsLoading(false);
      return;
    }
    let isMounted = true;

    new Promise((resolve, reject) => {
      dispatch(action({ payload, resolve, reject }));
    })
      .then((response) => {
        if (isMounted) setData(response);
      })
      .catch((error) => {
        if (typeof onError === 'function') {
          onError(error);
        }
      })
      .finally(() => {
        if (isMounted) setIsLoading(false);
      });

    return () => {
      isMounted = false;
    };
  }, [dispatch, action, payload, onError, enabled]);

  return { data, isLoading, setData };
};

export default useDispatchAction;
